import React, { useState, useEffect } from "react";
import './Section1.css';
import emailjs from "@emailjs/browser";
import mobileImage from './homeimage.png'; // Update path if needed

const Section1 = () => {

  const sendEmail = (e) => {
    e.preventDefault();
  
    const formData = new FormData(e.target);
    const data = {
      from_firstname: formData.get("from_firstname"),
      from_lastname: formData.get("from_lastname"),
      from_phonenumber: formData.get("from_phonenumber"),
      country: formData.get("country"),
      from_emailid: formData.get("from_emailid"),
      organization: formData.get("organization"),
      message: formData.get("message"),
    };
  
    console.log("Data being sent:", data);
  
    emailjs
      .send("service_nxepswl", "template_jumzlyr", data, "Ei4GRgZo9kOlQvyW9")
      .then((response) => {
        console.log("Email sent successfully", response);
        alert("Your message has been sent successfully!");
      })
      .catch((error) => {
        console.error("Email sending failed", error);
        alert("Sorry, something went wrong. Please try again later.");
      });
  };

  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      await sendEmail(event);
      togglePopup();
    } catch (error) {
      console.error("Error submitting the form:", error);
    }
  };
  

  return (
    <div className="section1">
      <div className="section1-content">
        <h1>
          EcoIndex App <br /> for <span className="highlight">Organizations</span>
        </h1>
        <p>Making Sustainability <br /> Actionable, Measurable & Rewarding</p>

        <div className="section1-buttons">
        <button style={{ '--clr': '#7808d0' }} className="button-app" onClick={togglePopup}
        
        
        >
              <span className="button__icon-wrapper">
                <svg
                  width="10"
                  className="button__icon-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 15"
                >
                  <path
                    fill="currentColor"
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  ></path>
                </svg>
                <svg
                  className="button__icon-svg button__icon-svg--copy"
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  fill="none"
                  viewBox="0 0 14 15"
                >
                  <path
                    fill="currentColor"
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  ></path>
                </svg>
              </span>
            Request a Demo
            </button>
            {isOpen && (
               
                <div className="demo-popup-overlay">
                  <div className="demo-popup-box">
                    <span className="demo-popup-close" onClick={togglePopup}>
                      &times;
                    </span>
                    <h2 className="demo-popup-title">
                      Schedule a Call <i className="fa fa-phone"></i>
                    </h2>
              
                    <form className="demo-popup-form" onSubmit={handleFormSubmit}>
                      <div className="demo-input-row">
                        <div className="demo-input-group demo-half-width">
                          <label>First Name</label>
                          <input type="text" name="from_firstname" required />
                        </div>
                        <div className="demo-input-group demo-half-width">
                          <label>Last Name</label>
                          <input type="text" name="from_lastname" required />
                        </div>
                      </div>
              
                      <div className="demo-input-row">
                        <div className="demo-input-group demo-half-width">
                          <label>Phone No.</label>
                          <input type="tel" name="from_phonenumber" required />
                        </div>
                        <div className="demo-input-group demo-half-width">
                          <label>Country</label>
                          <input type="text" name="country" required />
                        </div>
                      </div>
              
                      <div className="demo-input-group">
                        <label>Email</label>
                        <input type="email" name="from_emailid" required />
                      </div>
              
                      <div className="demo-input-group">
                        <label>Organization</label>
                        <input type="text" name="organization" required />
                      </div>
              
                      <div className="demo-input-group">
                        <label>What do you want to know?</label>
                        <textarea name="message" required></textarea>
                      </div>
              
                      <div className="demo-popup-buttons">
                        <button type="submit" className="demo-submit-btn">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              
            
            
    
<a
  href="/individualsapp"
  target="_blank"
  rel="noopener noreferrer"
  className="watch-btn"
>
  ▶ Watch Demo
</a>
        </div>
      </div>

      <div className="section1-image">
        <img src={mobileImage} alt="EcoIndex app on phones" />
      </div>

 

    </div>
  );
};

export default Section1;
